import { useTranslation, Trans } from 'react-i18next';
import { IconUser, IconLogout } from '@tabler/icons-react';
import { useAuthContext } from 'utils/contexts/AuthContext';
import Button from 'shared/Button';

const LoggedAsBanner = () => {
    const { t } = useTranslation();
    const { account, logout } = useAuthContext();

    if (!account.proxy_user) return null;

    return (
        <div className="flex items-center bg-green-100 w-full py-2 px-4 border-t-2 border-b-2 border-green-400 text-primary gap-6 text-base/none">
            <div className="flex flex-row items-center gap-1">
                <IconUser size={16} />
                <span role="status">
                    <Trans
                        i18nKey={`layout:logged-as-banner:text`}
                        components={{
                            span: <span className="font-semibold" />,
                        }}
                        values={{
                            fullName: account.proxy_user.full_name,
                        }}
                    />
                </span>
            </div>
            <Button onClick={() => logout()} color="unstyled">
                <span className="flex items-center gap-1 text-base/none">
                    <span>{t('layout:logged-as-banner:logout-button')}</span>
                    <IconLogout size={16} />
                </span>
            </Button>
        </div>
    );
};

export default LoggedAsBanner;
